<div class="mx-auto container-padding max-w-screen-desktop">
    <div class="max-w-4xl mx-auto py-12">
      <h1 class="text-[var(--dark-orange)] text-[45px]/[45px] font-normal mb-8">
        {{ documentData.title }}
      </h1>
  
      <section *ngFor="let section of documentData.sections" class="mb-8">
        <p class="text-[18px]/[27px] font-bold">
          {{ section.title }}
        </p>
  
        <div *ngFor="let content of section.content" class="mb-2">
          <p *ngIf="content.subtitle" class="text-[18px]/[27px] font-bold">
            {{ content.subtitle }}
          </p>
          <p *ngIf="content.text" class="text-[18px]/[27px] font-normal">
            {{ content.text }}
          </p>
          <ul *ngIf="content.list" class="list-disc pl-5 space-y-2 text-[18px]/[27px] font-normal">
            <li *ngFor="let item of content.list">{{ item }}</li>
          </ul>
        </div>
      </section>
    </div>
  </div>
  